import React from "react";
import {EntityListItems} from "../../components/List";
import {BaseInlineListHeadlineLayout, HeroBaseListItemLayout} from "./ListItemLayout";

import "./list.css"
import {classes, Root} from "./classes";

const ListItemLayout = (props) => {
    return <HeroBaseListItemLayout {...props} classes={classes} />
}

const InlineListHeadlineLayout = (props) => {
    return <BaseInlineListHeadlineLayout {...props} classes={classes} />
}

export const BaseList = ({ entity, pageContext, config, listItemLayout = ListItemLayout, inlineListHeadlineLayout = InlineListHeadlineLayout }) => {
    const listType = config?.listType || 'standard'

    return (
        <Root className={"list-type-" + listType} list-id={entity.identifier}>
            <EntityListItems entity={entity} pageContext={pageContext} config={config} listItemLayout={listItemLayout} inlineListHeadlineLayout={inlineListHeadlineLayout} />
        </Root>
    );
};
